import { AfterViewInit, Component, OnDestroy, ViewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { SeFeConfirmComponent } from 'se-fe-confirm';
import { DatadogService } from './services/datadog.service';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements AfterViewInit, OnDestroy {
  @ViewChild(SeFeConfirmComponent) confirmComponent: SeFeConfirmComponent;

  private readonly subscriptions = new Subscription();

  constructor(
    private datadogService: DatadogService,
    private router: Router
  ) {
    this.datadogService.initialize();
  }

  ngAfterViewInit(): void {
    this.subscriptions.add(
      this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe(() => {
        if (this.confirmComponent.modal.isOpen) {
          this.confirmComponent.modal.close();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
